module.exports = __webpack_public_path__ + "static/media/29ADMSPC25.80136068.jpg";